import React from 'react';
import theme from '../styles/theme';

// One small glyph per role so a user's status is visible at a glance.
// Used next to the username in the Header and on the Settings account tab.
const ROLE_META = {
  admin: {
    label: 'Administrator',
    color: theme.colors.warning.main,
    // shield with a check
    path: (
      <>
        <path d="M12 22C12 22 20 18 20 12V5L12 2L4 5V12C4 18 12 22 12 22Z" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M9 12L11 14L15 10" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      </>
    )
  },
  doctor: {
    label: 'Doctor',
    color: theme.colors.success.main,
    // medical cross in a circle
    path: (
      <>
        <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8" />
        <path d="M12 8V16M8 12H16" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      </>
    )
  },
  technician: {
    label: 'Technician',
    color: theme.colors.info.main,
    // wrench
    path: (
      <path d="M14.7 6.3C14.3 6.7 14.3 7.3 14.7 7.7L16.3 9.3C16.7 9.7 17.3 9.7 17.7 9.3L21.4 5.6C22.4 7.8 21.9 10.5 20.1 12.3C18.3 14.1 15.6 14.6 13.4 13.6L6.6 20.4C5.8 21.2 4.4 21.2 3.6 20.4C2.8 19.6 2.8 18.2 3.6 17.4L10.4 10.6C9.4 8.4 9.9 5.7 11.7 3.9C13.5 2.1 16.2 1.6 18.4 2.6L14.7 6.3Z" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    )
  },
  viewer: {
    label: 'Viewer',
    color: theme.colors.neutral.text.secondary,
    // eye
    path: (
      <>
        <path d="M1 12C1 12 5 5 12 5C19 5 23 12 23 12C23 12 19 19 12 19C5 19 1 12 1 12Z" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="1.8" />
      </>
    )
  }
};

function RoleIcon({ role, size = 16, withLabel = false }) {
  const meta = ROLE_META[role] || ROLE_META.viewer;

  return (
    <span
      title={meta.label}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        color: meta.color,
        verticalAlign: 'middle'
      }}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-label={meta.label}
        role="img"
      >
        {meta.path}
      </svg>
      {withLabel && (
        <span style={{ fontSize: '0.78rem', fontWeight: 600, letterSpacing: '0.01em', textTransform: 'capitalize' }}>{role}</span>
      )}
    </span>
  );
}

export default RoleIcon;
